import { memo, useMemo, FC } from 'react'
import * as styles from 'components/features/socialFeed/FeedPostPage/FeedPostPage.styl'
import { FeedInternalLayout, FeedExternalLayout } from 'components/layouts/Layouts'
import FeedPostListContainer from 'components/features/socialFeed/FeedPostList/FeedPostListContainer'
import { FeedResource, WithPostUid } from 'interfaces/feed'
import { Anchor as AnchorType, AnchorPlacement } from 'interfaces/navigation'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'

export type FeedPostPageInnerProps =
  & WithPostUid

export const FeedPostPageInner: FC<FeedPostPageInnerProps> = memo((props) => {
  const { postUid } = props

  const isAuthenticated = useStoreSelector(isAuthenticatedSelector)

  const resource = useMemo<FeedResource>(
    () => ({
      type: 'post',
      postUid,
    }),
    [postUid]
  )

  const feedpostAnchor: AnchorType = useMemo(() => {
    const anchorPlacement: AnchorPlacement = 'feedpost'

    return {
      anchor: anchorPlacement,
      id: postUid,
    }
  }, [postUid])

  const contentChild = useMemo(() => (
    <section className={ styles.column }>
      <FeedPostListContainer
        resource={ resource }
      />
    </section>
  ), [resource])

  if (isAuthenticated) {
    return (
      <FeedInternalLayout anchor={ feedpostAnchor } >
        {contentChild}
      </FeedInternalLayout>
    )
  }

  return (
    <FeedExternalLayout>
      { contentChild }
    </FeedExternalLayout>
  )
})
